import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import {Col} from "reactstrap";
import SimpleFileUploadField from "../components/SimpleFileUploadField";
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro upload CSV souboru.
 */
class UploadCsvForm extends Component<WithTranslation> {

    static formName = 'UploadCsvForm';

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (!values.soubor) {
            errors.soubor = t('validation.file_required');
        }
        if (!values.oddelovac) {
            errors.oddelovac = t('validation.value_required');
        }
        return errors;
    };

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <SimpleFileUploadField label={t('file')} name="soubor" accept=".csv" disabled={submitting}/>
                <ff.String label={t('field_separator')} name="oddelovac" disabled={submitting} addonsAfter={<Col xs={0} sm={10}/>}/>
                <CustomCheckboxField label={t('file_contains_header')} name="obsahujeHlavicku" disabled={submitting}/>
                <CustomCheckboxField label={t('cut_code_greater_than_30')} name="orezStrediskoKod" disabled={submitting}/>
                <CustomCheckboxField label={t('cut_name_greater_than_80')} name="orezStrediskoNazev" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} submitButton={t('load')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: UploadCsvForm.formName,
    validate: UploadCsvForm.validate,
})(UploadCsvForm)));
